module.exports = __webpack_public_path__ + "img/celebration.6805b6fe.gif";